module.exports = __webpack_public_path__ + "img/PLUS.c4c10a21.svg";